import { render } from "./LoginRegister1.vue?vue&type=template&id=77f68d1f&scoped=true"
import script from "./LoginRegister1.vue?vue&type=script&lang=js"
export * from "./LoginRegister1.vue?vue&type=script&lang=js"

import "./LoginRegister1.vue?vue&type=style&index=0&id=77f68d1f&lang=scss&scoped=true"

import exportComponent from "/home/apps/jingo_web_full/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f68d1f"]])

export default __exports__